import React from 'react';

import UserFilter from 'components/Filters/UserFilter';

import { Filter } from '@gogame/filters';

import {
  FILTER_STATUSES,
  FILTER_PARTNER_COMPANIES,
  FILTER_BUSINESS_PARTNERS,
  FILTER_CAMPAIGN_NETWORKS,
  FILTER_CAMPAIGN_APPLICATIONS,
  FILTER_CAMPAIGN_PLATFORMS,
  FILTER_CAMPAIGN_CLUSTERS,
  FILTER_TRAFFIC_TYPES,
  FILTER_EXPENSE_TYPES,
  FILTER_OWNERS,
  FILTER_CREATED_BY,
  FILTER_CHANNELS,
  FILTERS_DEPENDENCIES as DEPENDENCIES,
  FILTER_CHANNEL_TYPE,
} from 'scenes/Affiliates/constants';
import * as filtersSource from 'scenes/Affiliates/sources/filters';

export const Statuses = (props) => {
  return (
    <Filter.MultiSelect
      title={'Statuses'}
      name={FILTER_STATUSES}
      source={filtersSource.loadStatuses}
      depends={DEPENDENCIES[FILTER_STATUSES]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const PartnerCompanies = (props) => {
  return (
    <Filter.MultiSelect
      title={'Partner Companies'}
      name={FILTER_PARTNER_COMPANIES}
      source={filtersSource.loadPartnerCompanies}
      depends={DEPENDENCIES[FILTER_PARTNER_COMPANIES]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const BusinessPartners = (props) => {
  return (
    <Filter.MultiSelect
      title={'Business Partners'}
      name={FILTER_BUSINESS_PARTNERS}
      source={filtersSource.loadBusinessPartners}
      depends={DEPENDENCIES[FILTER_BUSINESS_PARTNERS]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Networks = (props) => {
  return (
    <Filter.MultiSelect
      title={'Networks (by campaigns)'}
      name={FILTER_CAMPAIGN_NETWORKS}
      source={filtersSource.loadNetworks}
      withAll={false}
      depends={DEPENDENCIES[FILTER_CAMPAIGN_NETWORKS]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Applications = (props) => {
  return (
    <Filter.MultiSelect
      title={'Applications (by campaigns)'}
      name={FILTER_CAMPAIGN_APPLICATIONS}
      source={filtersSource.loadApplications}
      depends={DEPENDENCIES[FILTER_CAMPAIGN_APPLICATIONS]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Platforms = (props) => {
  return (
    <Filter.MultiSelect
      title={'Platforms (by campaigns)'}
      name={FILTER_CAMPAIGN_PLATFORMS}
      source={filtersSource.loadPlatforms}
      withAll={false}
      depends={DEPENDENCIES[FILTER_CAMPAIGN_PLATFORMS]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Clusters = (props) => {
  return (
    <Filter.MultiSelect
      title={'Clusters (by campaigns)'}
      name={FILTER_CAMPAIGN_CLUSTERS}
      source={filtersSource.loadClusters}
      withAll={false}
      depends={DEPENDENCIES[FILTER_CAMPAIGN_CLUSTERS]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const TrafficTypes = (props) => {
  return (
    <Filter.MultiSelect
      title={'Traffic Types'}
      name={FILTER_TRAFFIC_TYPES}
      source={filtersSource.loadTrafficTypes}
      depends={DEPENDENCIES[FILTER_TRAFFIC_TYPES]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const ExpenseTypes = (props) => {
  return (
    <Filter.MultiSelect
      title={'Expense Types'}
      name={FILTER_EXPENSE_TYPES}
      source={filtersSource.loadExpenseTypes}
      depends={DEPENDENCIES[FILTER_EXPENSE_TYPES]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const Owners = (props) => {
  return (
    <UserFilter
      title={'Owners'}
      name={FILTER_OWNERS}
      source={filtersSource.loadOwners}
      withAll={false}
      depends={DEPENDENCIES[FILTER_OWNERS]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const CreatedBy = (props) => {
  return (
    <UserFilter
      title={'Created By'}
      name={FILTER_CREATED_BY}
      source={filtersSource.loadCreatedBy}
      depends={DEPENDENCIES[FILTER_CREATED_BY]}
      placeholder={'All'}
      {...props}
    />
  );
};

export const ChannelType = (props) => {
  return (
    <Filter.Select
      title={'Channel Type'}
      name={FILTER_CHANNEL_TYPE}
      source={filtersSource.loadChannelType}
      placeholder={'Select channel type'}
      {...props}
    />
  );
};

export const Channels = (props) => {
  return (
    <Filter.MultiSelect
      title={'Channels'}
      name={FILTER_CHANNELS}
      source={filtersSource.loadChannels}
      withAll={false}
      placeholder={'All'}
      depends={DEPENDENCIES[FILTER_CHANNELS]}
      {...props}
    />
  );
};
